import React from 'react';
import CommonPageWrapper from '../../../components/CommonPageWrapper';
import {Stack, Typography, Divider, List, ListItem} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const styles = {
  header: {
    paddingTop: '5rem',
    paddingLeft: '3rem',
    height: '100%',
  },
  greeting: {
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '140%',
    color: '#162523',
  },
  title: {
    marginBottom: '0.5rem',
  },
  divider: {
    marginLeft: '-3rem !important',
    marginTop: '1.5rem !important',
    marginBottom: '2rem !important',
    border: '0.5px solid rgba(0, 0, 0, 0.87) !important',
  },
  listItem: {
    width: '40rem',
    height: '5rem',
    border: '1px solid #DFE5E2',
    marginBottom: '1rem',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  firstListItemIcon: {
    position: 'relative',
    left: '21rem',
  },
  secondListItemIcon: {
    position: 'relative',
    left: '19.75rem',
  },
  subTitle: {
    color: '#657O6D',
    fontWeight: 400,
  },
};

const Reporting = () => {
  const navigate = useNavigate();
  return (
    <CommonPageWrapper sx={styles.header}>
      <Stack flex={1} spacing={1}>
        <Typography variant={'subtitle2'} sx={{color: '#626D6A'}}>
          Settings
        </Typography>
        <Typography variant={'h4'}>Reporting</Typography>
        <Divider sx={styles.divider} />
        <Typography variant={'h6'} sx={styles.title}>
          Configuration Items
        </Typography>
        <List>
          <ListItem
            sx={styles.listItem}
            onClick={() => navigate('/settings/reporting/accounts')}
          >
            <Stack justifyContent={'space-between'}>
              <Typography variant={'subtitle2'}>
                <strong>Chart of Accounts</strong>
              </Typography>
              <Typography variant={'caption'} sx={styles.subTitle}>
                Preview and manage your account mappings
              </Typography>
            </Stack>
            <ChevronRightIcon sx={styles.firstListItemIcon} />
          </ListItem>
          <ListItem
            sx={styles.listItem}
            onClick={() => navigate('/settings/reporting/departments')}
          >
            <Stack justifyContent={'space-between'}>
              <Typography variant={'subtitle2'}>
                <strong>Departments</strong>
              </Typography>
              <Typography variant={'caption'} sx={styles.subTitle}>
                Preview and manage your department mappings
              </Typography>
            </Stack>
            <ChevronRightIcon sx={styles.secondListItemIcon} />
          </ListItem>
        </List>
      </Stack>
    </CommonPageWrapper>
  );
};

export default Reporting;
